export const ADD_BALANCE_ERROR = "ADD_BALANCE_ERROR";
export const ADD_BALANCE_LOADING = "ADD_BALANCE_LOADING";
export const ADD_BALANCE_SUCCESS = "ADD_BALANCE_SUCCESS";

export const UPDATE_BALANCE_ERROR = "UPDATE_BALANCE_ERROR";
export const UPDATE_BALANCE_LOADING = "UPDATE_BALANCE_LOADING";
export const UPDATE_BALANCE_SUCCESS = "UPDATE_BALANCE_SUCCESS";

export const FETCH_BALANCE_ERROR = "FETCH_BALANCE_ERROR";
export const FETCH_BALANCE_LOADING = "FETCH_BALANCE_LOADING";
export const FETCH_BALANCE_SUCCESS = "FETCH_BALANCE_SUCCESS";

export const FETCH_BY_ID_BALANCE_ERROR = "FETCH_BY_ID_BALANCE_ERROR";
export const FETCH_BY_ID_BALANCE_LOADING = "FETCH_BY_ID_BALANCE_LOADING";
export const FETCH_BY_ID_BALANCE_SUCCESS = "FETCH_BY_ID_BALANCE_SUCCESS";

export const DELETE_BALANCE_ERROR = "DELETE_BALANCE_ERROR";
export const DELETE_BALANCE_LOADING = "DELETE_BALANCE_LOADING";
export const DELETE_BALANCE_SUCCESS = "DELETE_BALANCE_SUCCESS";

export const UPDATE_USER_BALANCE_LOADING = 'UPDATE_USER_BALANCE_LOADING';
export const UPDATE_USER_BALANCE_SUCCESS = 'UPDATE_USER_BALANCE_SUCCESS';
export const UPDATE_USER_BALANCE_ERROR = 'UPDATE_USER_BALANCE_ERROR'; 

export const FETCH_HISTORY_LOADING = "FETCH_HISTORY_LOADING";
export const FETCH_HISTORY_SUCCESS = "FETCH_HISTORY_SUCCESS";
export const FETCH_HISTORY_ERROR = "FETCH_HISTORY_ERROR";

export const FETCH_USER_HISTORY_LOADING = 'FETCH_USER_HISTORY_LOADING';
export const FETCH_USER_HISTORY_SUCCESS = 'FETCH_USER_HISTORY_SUCCESS';
export const FETCH_USER_HISTORY_ERROR = 'FETCH_USER_HISTORY_ERROR';
